import React from 'react';
import styles from './CheckboxArray.module.scss';
import uuid from 'uuid/v4';

const CheckboxArray = (props) => {

  const checkboxes = props.values.map((value, index) => {

    const id = index + uuid.v4();
    let element = {};

    if (typeof value !== 'function' && typeof value !== 'object') {
      element = {
        label: value,
        value: value
      }

      

    }
    else element = value;

    //check for acitve param otherwise try find if current state has already been selected with props.value
    const isActive = element.active ? element.active : props.value?.find(el => el === element.value)

    const onChange = props.handleChange ? (e) => props.handleChange(e, element.value, props.name) : null;

    return <li className={props.className + ' ' + styles.CheckboxArray} key={index}>
      <input id={id} name={props.name} data-label={element.label} onChange={onChange} type={props.type || 'checkbox'} checked={isActive} />
      <label htmlFor={id}>{element.label}</label>
    </li>

  });
  return checkboxes;
};

export default CheckboxArray;